/**
 * Created by zlj on 2020/3/30.
 */
import Vue from 'vue'

export default new Vue



// WEBPACK FOOTER //
// ./src/transform/trans.js